<template>
  <div>
    <ul v-show="menuVisible" :style="{ left: left + 'px', top: top + 'px' }" class="contextmenu">
      <slot name="menuList"></slot>
      <el-dropdown-item size="mini" icon="el-icon-edit" @click.native="handleTableHeaderMenu()">
        <span>选择列…</span>
      </el-dropdown-item>
    </ul>
    <el-dialog :visible.sync="dialogFormVisible" :append-to-body="true" :width="checkPermission(['developer'])?'80%':'30%'" title="选择列">
      <div class="flex_between_center">
        <div>
          <el-button type="primary" size="mini" @click="handleReset">重置</el-button>
          <el-button type="primary" size="mini" @click="handleAllCheck">全选</el-button>
          <el-button type="primary" size="mini" @click="handleInverse">反选</el-button>
        </div>
        <div>
          <el-button v-if="checkPermission(['developer'])" type="danger" size="mini" @click="handleSave4Normal">设为默认配置(开发用)</el-button>

        </div>
      </div>
      <el-divider content-position="left">拖拽鼠标可以调整字段顺序</el-divider>
      <div v-if="dialogFormVisible" style="height:400px;overflow-y:auto">
        <!-- <el-tree ref="tree" :data="list" node-key="base_detail_id" default-expand-all @node-drag-end="nodeDragEnd" :allow-drop="allowDrop" show-checkbox draggable :props="defaultProps">
      </el-tree> -->
        <el-table
          v-loading="listLoading"
          ref="table"
          key="1"
          :data="list"
          :cell-class-name="cellName"
          class="droptable"
          border
          fit
          highlight-current-row
          style="width: 100%;"
          height="400"
          row-key="base_detail_id"
          @selection-change="handleSelectionChange">
          <el-table-column prop="drag" align="center" label="拖拽" width="40">
            <template slot-scope="scope">
              <i class="el-icon-rank"></i>
            </template>
          </el-table-column>
          <el-table-column type="selection" width="40"/>
          <el-table-column label="列名" prop="field_name" align="left" width="80">
            <template slot-scope="scope">
              <span>{{ scope.row.field_name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="固定列" prop="freeze_type" align="center">
            <template slot-scope="scope">
              <el-select v-trim v-model="scope.row.freeze_type" clearable placeholder="靠边" style="width: 100%;" class="filter-item">
                <el-option v-for="item in freeze_type_list" :key="item.value" :label="item.label" :value="item.value"/>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column v-if="checkPermission(['developer'])" label="列类型" width="100" prop="field_input_type" align="center">
            <template slot-scope="scope">
              <el-select v-trim v-model="scope.row.field_input_type" clearable placeholder="列类型" style="width: 100%;" class="filter-item">
                <el-option v-for="item in field_input_type_list" :key="item.value" :label="item.name" :value="item.value"/>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column v-if="checkPermission(['developer'])" label="字段类型" width="150" prop="field_type" align="center">
            <template slot-scope="scope">
              <el-select v-trim v-model="scope.row.field_type" clearable placeholder="字段类型" style="width: 100%;" class="filter-item">
                <el-option v-for="item in field_type_list" :key="item.value" :label="item.name" :value="item.value"/>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column v-if="checkPermission(['developer'])" label="编辑类型" width="120" prop="field_value_type" align="center">
            <template slot-scope="scope">
              <el-select v-trim v-if="scope.row.field_input_type == 'caninput'" v-model="scope.row.field_value_type" clearable placeholder="编辑类型" style="width: 100%;" class="filter-item">
                <el-option v-for="item in field_value_type_list" :key="item.value" :label="item.name" :value="item.value"/>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="数据源" width="150" prop="field_data_value" align="center">
            <template slot-scope="scope">
              <el-button
                v-trim
                v-if="scope.row.field_value_type == 'select'"
                v-model="scope.row.field_data_value"
                size="mini"
                style="width:100%"
                @click="openDataSource($event, scope.row, scope.$index)"
              >{{
                !scope.row.data_source_name
                  ? "选择数据源"
                  : scope.row.data_source_name
              }}</el-button
              >
            </template>
          </el-table-column>
          <el-table-column v-if="checkPermission(['developer'])" label="默认是否可见" width="100" prop="user_visible" align="center">
            <template slot-scope="scope">
              <el-checkbox v-trim v-model="scope.row.user_visible" :true-label="1" :false-label="0"/>
            </template>
          </el-table-column>
          <el-table-column v-if="checkPermission(['developer'])" label="是否隐藏过长内容" width="120" prop="show_tooltip" align="center">
            <template slot-scope="scope">
              <el-checkbox v-trim v-model="scope.row.show_tooltip" :true-label="1" :false-label="0"/>
            </template>
          </el-table-column>
          <el-table-column v-if="checkPermission(['developer'])" label="是否插槽" width="80" prop="is_slot" align="center">
            <template slot-scope="scope">
              <el-checkbox v-trim v-model="scope.row.is_slot" :true-label="1" :false-label="0"/>
            </template>
          </el-table-column>
          <el-table-column v-if="checkPermission(['developer'])" label="备注" width="150" prop="memo" align="center">
            <template slot-scope="scope">
              <el-input v-trim v-model="scope.row.memo" type="textarea" size="mini"/>
            </template>
          </el-table-column>
          <el-table-column v-if="checkPermission(['developer'])" label="是否排序" width="120" prop="is_sort" align="center">
            <template slot-scope="scope">
              <el-checkbox v-trim v-model="scope.row.is_sort" :true-label="1" :false-label="0"/>
            </template>
          </el-table-column>

        </el-table>
      </div>
      <!-- 数据源弹窗 -->
      <DataSourceConfiguration
        ref="DataSourceConfiguration"
        @getDataSource="getDataSource"
      />
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetUserListField,
  SaveUserListFieldConf,
  RecoveryDefaultListFieldConf,
  EditUserListFieldWidthConf,
  SetDefaultListFieldConf
} from '@/api/erpCommon'
import { GetBaseDataByCodetype } from '@/api/common'
import Sortable from 'sortablejs'
import checkPermission from '@/utils/permission' // 权限判断函数
import DataSourceConfiguration from '@/views/system/components/DataSourceConfiguration'
export default {
  components: { DataSourceConfiguration },
  props: {
    method: {
      type: String
    },
    append: {
      type: String,
      default: 'body'
    },
    offsetX: {
      type: Number,
      default: 0
    },
    offsetY: {
      type: Number,
      default: 0
    },
    fieldList: {
      type: Array,
      default: () => []
    }

  },
  data() {
    return {
      menuVisible: false,
      top: 0,
      left: 0,
      dialogFormVisible: false,
      listLoading: false,
      list: [],
      multipleSelection: [],
      freeze_type_list: [
        { label: '不固定', value: '' },
        { label: '左边固定', value: 'left' },
        { label: '右边固定', value: 'right' }
      ], // 固定列
      text_align_list: [
        { label: '左', value: 'left' },
        { label: '右', value: 'right' },
        { label: '中', value: 'center' }
      ], // 靠边
      defaultProps: {
        children: 'children',
        label: 'field_name'
      },
      field_type_list: [],
      field_input_type_list: [],
      field_value_type_list: []
    }
  },
  watch: {
    menuVisible(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    },
    // 通过父组件传过来的表头数据，方便拖动改变宽度以及后续其他操作
    fieldList: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.list = newVal
        }
      },
      deep: true
    }
    /* method: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.getHeaderMenu()
        }
      },
      immediate: true,
      deep: true
    } */
  },
  mounted() {},
  created() {
  },
  destroyed() {},
  methods: {
    getInfo() {
      GetBaseDataByCodetype({ codetype: 'conf_field_type' }).then(response => {
        if (response.data.res_status_code === '0') {
          this.field_type_list = response.data.res_content
        } else {
          this.$message({
            type: 'error',
            message: response.data.res_message
          })
        }
      })
      GetBaseDataByCodetype({ codetype: 'field_input_type' }).then(response => {
        if (response.data.res_status_code === '0') {
          this.field_input_type_list = response.data.res_content
        } else {
          this.$message({
            type: 'error',
            message: response.data.res_message
          })
        }
      })
      GetBaseDataByCodetype({ codetype: 'field_type' }).then(response => {
        if (response.data.res_status_code === '0') {
          this.field_value_type_list = response.data.res_content
        } else {
          this.$message({
            type: 'error',
            message: response.data.res_message
          })
        }
      })
    },
    getHeaderMenu() {
      this.listLoading = true
      GetUserListField({ function_method: this.method }).then(response => {
        this.listLoading = false
        if (response.data.res_status_code == 0) {
          this.list = response.data.res_content.field_list
          this.$nextTick(() => {
            if (this.dialogFormVisible) {
              this.rowDrop()
              this.handleRowSelection()
            }
          })
        } else {
          this.$message({
            type: 'error',
            message: response.data.res_message
          })
        }
      })
    },
    openMenu(column, event) {
      const menuMinWidth = 105
      const offsetLeft = this.$el.getBoundingClientRect().left // container margin left
      const offsetWidth = this.$el.offsetWidth // container width
      const maxLeft = offsetWidth - menuMinWidth // left boundary
      const left = event.x - offsetLeft + 20 // 20: margin right
      event.returnValue = false
      if (left > maxLeft) {
        this.left = maxLeft
      } else {
        this.left = left
      }
      this.left = this.left - this.offsetX
      if (this.append == 'dialog') {
        this.top = event.clientY - 140 - this.offsetY
      }
      if (this.append == 'body') {
        this.top = event.clientY - 80 - this.offsetY
      }
      this.menuVisible = true
    },
    closeMenu() {
      this.menuVisible = false
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    cellName({ row, column, rowIndex, columnIndex }) {
      if (column.property == 'drag') {
        return 'el_drag_cell'
      }
    },
    // 行拖拽
    rowDrop() {
      const el = document.querySelectorAll(
        '.droptable>.el-table__body-wrapper > table > tbody'
      )[0]
      this.sortable = Sortable.create(el, {
        ghostClass: 'sortable-ghost', // Class name for the drop placeholder,
        handle: '.el_drag_cell',
        setData: function(dataTransfer) {
          dataTransfer.setData('Text', '')
        },
        onEnd: evt => {
          const targetRow = this.list.splice(evt.oldIndex, 1)[0]
          this.list.splice(evt.newIndex, 0, targetRow)
          this.list.forEach((element, index) => {
            this.$set(element, 'field_sort', index * 10)
          })
        }
      })
    },
    async handleTableHeaderMenu() {
      this.getInfo()
      this.method && this.getHeaderMenu()
      this.dialogFormVisible = true
      await this.$nextTick()
      this.rowDrop()
      this.handleRowSelection()
    },
    handleRowSelection() {
      this.$refs.table.clearSelection()
      this.list.forEach(row => {
        if (row.is_show == '1') {
          this.$refs.table.toggleRowSelection(row)
        }
      })
    },
    handleSubmit() {
      const list = Object.assign([], this.list)
      const checkList = this.multipleSelection
      if (checkList.length < 1) {
        this.$message({
          type: 'error',
          message: '至少选择一个列'
        })
        return false
      }
      list.forEach(element => {
        element.is_show = '0'
        checkList.forEach(a => {
          if (element.field_code == a.field_code) {
            element.is_show = '1'
          }
        })
      })
      SaveUserListFieldConf({
        function_method: this.method,
        field_list: list
      }).then(response => {
        if (response.data.res_status_code == 0) {
          this.$message({
            type: 'success',
            message: '修改成功'
          })
          this.dialogFormVisible = false
          this.$emit('refresh')
        } else {
          this.$message({
            type: 'error',
            message: response.data.res_message
          })
        }
      })
    },
    handleDragent(newWidth, oldWidth, column, event) {
      let newObj = {}
      this.list.forEach(element => {
        if (element.field_code == column.property) {
          element.field_width = newWidth
          newObj = Object.assign({}, element)
        }
      })
      EditUserListFieldWidthConf(newObj).then(response => {
        if (response.data.res_status_code == 0) {
          // this.$emit("refresh");
        } else {
          this.$message({
            type: 'error',
            message: response.data.res_message
          })
        }
      })
    },
    handleAllCheck() {
      this.$refs.table.toggleAllSelection()
    },
    handleInverse() {
      this.list.forEach(row => {
        this.$refs.table.toggleRowSelection(row)
      })
    },
    handleReset() {
      RecoveryDefaultListFieldConf({
        function_method: this.method
      }).then(response => {
        if (response.data.res_status_code == 0) {
          this.$emit('refresh')
          this.dialogFormVisible = false
        } else {
          this.$message({
            type: 'error',
            message: response.data.res_message
          })
        }
      })
    },
    handleSave4Normal() {
      SetDefaultListFieldConf({
        function_method: this.method,
        field_list: this.list
      }).then(response => {
        if (response.data.res_status_code == 0) {
          this.$message({
            type: 'success',
            message: '保存成功'
          })
          this.dialogFormVisible = false
          // this.getList();
        } else {
          this.$message({
            type: 'error',
            message: response.data.res_message
          })
        }
      })
    },
    async openDataSource(e, row, index) {
      this.index = index
      this.$refs.DataSourceConfiguration.handleOpenDialog()
    },
    // 获取数据源
    getDataSource(item) {
      this.list.forEach((ele, index) => {
        if (index === this.index) {
          ele.data_source_name = item.data_name
          ele.field_data_value = item.data_source_code
          this.$set(this.list, index, ele)
        }
      })
    },
    checkPermission
  }
}
</script>

<style lang="scss" scoped>
.contextmenu li {
  padding: 5px 15px;
  font-size: 12px;
  line-height: 20px;
}
/deep/.sortable-ghost {
  opacity: 0.8;
  color: #fff !important;
  background-color: #42b983 !important;
}
</style>
